import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import axios from 'axios'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { useUserStore } from './stores/Global';
import { createI18n } from 'vue-i18n';
import local from '../../share-source/src/config/local'

const app = createApp(App)
app.use(router)
app.use(ElementPlus)  // Use Element Plus globally

const locale = localStorage.getItem('locale')
if (!locale) {
  localStorage.setItem('locale', 'en')
}

app.use(createI18n({
  locale: locale,
  messages: local
}))

// Create Pinia instance
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(pinia)

const userStore = useUserStore();

axios.defaults.withCredentials = true;
// Add response interceptor to handle session errors
axios.interceptors.response.use(
  response => response,
  error => {
    if (!error || !error.response) {
      return Promise.reject(error);
    }

    if (error.response.status === 401 || error.response.status === 403) {
      // Redirect to login page
      // this.$message.error('Please login again.');
      console.log('redirect to login page');
      userStore.logout();
      router.push('/backend-login');
    } else if (error.response.status === 500) {
      // this.$message.error(error);
      // this.$message.error("internal server error.");
    }
    console.log(error);
    return Promise.reject(error);
  }
);

app.mount('#app')